import { COLUMN_CONTROLLER, COLUMN_DOORS_COUNT, COLUMN_FIXED_ADDRESS, COLUMN_IP_ADDRESS, COLUMN_NAME, COLUMN_SITE, COLUMN_TYPE, COLUMN_LICENSED, COLUMN_MUSTERING_POINT, COLUMN_READER_SERIAL } from "../../constants/column-types";
import { FILTER_DOORS, FILTER_SITES, FILTER_CONTROLLER } from "../../constants/filter-types";
import { TranslationKeys } from "../../contexts/TranslationKeys";
import { Translator } from "../../contexts/translator";
import { TableColumn } from "../table/TableColumn";

const ReaderColumns: TableColumn[] = [
    {
        heading: "Name",
        accessor: "name",
        isNumeric: false,
        id: 0,
        sortByName: "devName",
        sortDirection: "asc",
        active: true,
        translationKey: "name",
        isDefault: true,
        columnId: COLUMN_NAME,
    },
    {
        heading: "Fixed Address",
        accessor: "fixedAddress",
        isNumeric: false,
        id: 1,
        sortByName: "devFixedAddr",
        sortDirection: "asc",
        active: true,
        translationKey: "fixedAddress",
        columnId: COLUMN_FIXED_ADDRESS,
    },
    {
        heading: "IP Address",
        accessor: "ipAddress",
        isNumeric: false,
        id: 2,
        sortByName: "devIpAddress",
        sortDirection: "asc",
        active: true,
        translationKey: "ipAddress",
        columnId: COLUMN_IP_ADDRESS,
    },
    {
        heading: "Type",
        accessor: "type",
        isNumeric: false,
        id: 3,
        sortByName: "unitType.trnName",
        sortDirection: "asc",
        active: true,
        translationKey: "type",
        columnId: COLUMN_TYPE,
    },
    {
        heading: "Licensed",
        accessor: "devLicense",
        isNumeric: false,
        id: 4,
        sortByName: "devLicense",
        sortDirection: "asc",
        active: true,
        translationKey: "licensed",
        columnId: COLUMN_LICENSED,
        warning: (row, translate: Translator) => {
            if (row.pendingLicense) {
                return {
                    message: translate.byKeyFormatted(TranslationKeys.mobileLicensePending, {deviceSerial: row.devReaderSerial}),
                    tooltip: translate.byKey(TranslationKeys.pendingUpdate),
                    title: translate.byKey(TranslationKeys.warning)
                }
            }

            return undefined;
        }
    },
    {
        heading: "Reader Serial",
        accessor: "devReaderSerial",
        isNumeric: false,
        id: 5,
        sortByName: "devReaderSerial",
        sortDirection: "asc",
        active: true,
        translationKey: "readerSerial",
        columnId: COLUMN_READER_SERIAL
    },
    {
        heading: "Site",
        accessor: "site",
        isNumeric: false,
        id: 6,
        sortByName: "site.siteName",
        sortDirection: "asc",
        active: true,
        searchOnName: "site.id",
        lookupName: "site.siteName",
        translationKey: "site",
        filterId: FILTER_SITES,
        columnId: COLUMN_SITE,
        settingDataName: "site"
    },
    {
        heading: "Controller",
        accessor: "controller",
        isNumeric: false,
        id: 7,
        sortByName: "controller.devName",
        sortDirection: "asc",
        active: true,
        searchOnName: "controller.deviceImprox.id",
        lookupName: "controller.deviceImprox.devName",
        translationKey: "controller",
        columnId: COLUMN_CONTROLLER,
        filterId: FILTER_CONTROLLER,
        settingDataName: "deviceImprox"
    },
    {
        heading: "Door",
        accessor: "door",
        isNumeric: false,
        id: 8,
        sortByName: "location.locName",
        sortDirection: "asc",
        active: true,
        searchOnName: "location.id",
        lookupName: "location.locName",
        translationKey: "door",
        columnId: COLUMN_DOORS_COUNT,
        filterId: FILTER_DOORS,
        settingDataName: "location"
    },
    {
        heading: "Preset",
        accessor: "preset",
        isNumeric: false,
        id: 9,
        // sortDirection: "asc",
        active: true,
        translationKey: "preset"
    },
    {
        heading: "Mustering Point",
        accessor: "musteringPointLabel",
        isNumeric: false,
        id: 10,
        sortByName: "musteringPoint",
        sortDirection: "asc",
        active: true,
        translationKey: "musteringPoint",
        columnId: COLUMN_MUSTERING_POINT 
    },
    {
        heading: "Lift",
        accessor: "liftName",
        isNumeric: false,
        id: 11,
        active: false,
        translationKey: "lift",
        // columnId: COLUMN_LIFT
    }
];


export default ReaderColumns;
